import { getFormattedDate } from '../../../utils/dateHelper';
import { DepositModel } from '../../Deposit/model/deposit-model';
import { HistoryFilter } from '../model/HistoryFilter';
import { HistoryQueryRequest } from '../model/HistoryQueryRequest';

export const buildHistoryQueryParams = (historyFilter: HistoryFilter): HistoryQueryRequest => {
  return {
    restaurantIds: historyFilter.restaurantIds,
    orderField: historyFilter.orderField,
    orderType: historyFilter.orderType,
    startDate: getFormattedDate(historyFilter.startDate.toString()),
    ...(historyFilter.endDate && { endDate: getFormattedDate(historyFilter.endDate.toString()) }),
    ...(historyFilter.action && { action: historyFilter.action }),
    ...(historyFilter.orderId && { orderId: historyFilter.orderId }),
  };
};

export const getDepositHistoryActionLabel = (action: string, deposit?: DepositModel): string => {
  return deposit ? `${action} (${deposit.amount.format(deposit.currency)})` : action;
};
